/**
 *
 * ResourceType
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
const styles = theme => ({
  root: {
    ...theme.typography.pxSmall,
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
});

function getResourceUrl(type) {
  const baseResourceUrl = '/resources?types=';
  const presentationUrl = '&presentation=mixed';
  return `${baseResourceUrl}${type}${presentationUrl}`;
}

function getUrlByType(type) {
  let redirectUrl = '/';
  switch (type) {
    case 'APP':
      redirectUrl = getResourceUrl('Apps');
      break;
    case 'BOOK':
      redirectUrl = getResourceUrl('Books');
      break;
    case 'ORGANIZATION':
      redirectUrl = getResourceUrl('Organizations');
      break;
    case 'PEOPLE':
      redirectUrl = getResourceUrl('People');
      break;
    case 'PODCAST':
      redirectUrl = getResourceUrl('Podcasts');
      break;
    case 'VIDEO':
      redirectUrl = getResourceUrl('Videos');
      break;
    case 'Online Program':
      redirectUrl = getResourceUrl('Online Programs');
      break;
    case 'ARTICLE':
      redirectUrl = getResourceUrl('Articles');
      break;
    case 'News':
      redirectUrl = '/news';
      break;
    default:
      break;
  }

  return redirectUrl;
}
function ResourceType(props) {
  const { type, classes } = props;
  const url = getUrlByType(type);
  return (
    <Link to={url} className={classes.root}>
      {type}
    </Link>
  );
}

ResourceType.propTypes = {
  type: PropTypes.string,
  classes: PropTypes.object,
};

export default withStyles(styles)(ResourceType);
